import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGame } from '../contexts/GameContext';
import '../styles/Admin.css';

const Admin = () => {
  const navigate = useNavigate();
  const { honeyTypes, setCustomHoneyOrder, getCustomHoneyOrder } = useGame();
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [selectedHoneys, setSelectedHoneys] = useState({
    sample1: '',
    sample2: '',
    sample3: ''
  });
  const [successMessage, setSuccessMessage] = useState('');

  // Cargar configuración actual al iniciar
  useEffect(() => {
    const currentConfig = getCustomHoneyOrder();
    if (currentConfig) {
      setSelectedHoneys({
        sample1: currentConfig[0] || '',
        sample2: currentConfig[1] || '',
        sample3: currentConfig[2] || ''
      });
    }
  }, [getCustomHoneyOrder]);

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    // Contraseña simple para demostración - en producción usar algo más seguro
    if (password === 'mielmaster2023') {
      setIsAuthenticated(true);
    } else {
      alert('Contraseña incorrecta');
    }
  };

  const handleHoneySelection = (sample, honeyId) => {
    // Verificar si esta miel ya está seleccionada en otra muestra
    const currentSelections = Object.entries(selectedHoneys);
    for (const [key, value] of currentSelections) {
      if (key !== sample && value === honeyId) {
        // Preguntar si desea intercambiar las mieles
        const confirmSwap = window.confirm(
          `Esta miel ya está asignada a otra muestra. ¿Desea intercambiarlas?`
        );
        
        if (confirmSwap) {
          // Intercambiar las mieles
          setSelectedHoneys(prev => ({
            ...prev,
            [key]: prev[sample],
            [sample]: honeyId
          }));
        }
        return;
      }
    }

    // Si no hay conflicto, actualizar normalmente
    setSelectedHoneys(prev => ({
      ...prev,
      [sample]: honeyId
    }));
  };

  const handleSaveConfiguration = () => {
    // Verificar que todas las muestras tengan una miel asignada
    if (!selectedHoneys.sample1 || !selectedHoneys.sample2 || !selectedHoneys.sample3) {
      alert('Por favor, asigne un tipo de miel a cada muestra');
      return;
    }

    // Verificar que no haya mieles duplicadas
    const uniqueHoneys = new Set([selectedHoneys.sample1, selectedHoneys.sample2, selectedHoneys.sample3]);
    if (uniqueHoneys.size !== 3) {
      alert('Cada muestra debe tener un tipo de miel diferente');
      return;
    }

    // Guardar la configuración
    const honeyOrder = [selectedHoneys.sample1, selectedHoneys.sample2, selectedHoneys.sample3];
    
    try {
      // Guardar en el contexto
      setCustomHoneyOrder(honeyOrder);
      
      // Guardar directamente en localStorage como respaldo
      localStorage.setItem('mielMasterCustomOrder', JSON.stringify(honeyOrder));
      
      console.log('Configuración guardada:', honeyOrder);
      
      // Mostrar mensaje de éxito
      setSuccessMessage('Configuración guardada correctamente');
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (error) {
      console.error('Error al guardar la configuración:', error);
      alert('Hubo un error al guardar la configuración. Por favor, intente nuevamente.');
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-login-container">
        <h1>Acceso Administrativo</h1>
        <form onSubmit={handlePasswordSubmit} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="password">Contraseña:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="admin-login-button">Acceder</button>
        </form>
        <button 
          className="back-button"
          onClick={() => navigate('/')}
        >
          Volver al Inicio
        </button>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <h1>Configuración de Muestras</h1>
      
      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}
      
      <div className="admin-content">
        <div className="samples-configuration">
          {['sample1', 'sample2', 'sample3'].map((sample, index) => (
            <div key={sample} className="sample-selector">
              <h3>Muestra {index + 1}</h3>
              <div className="honey-options">
                {honeyTypes.map(honey => (
                  <div 
                    key={honey.id}
                    className={`honey-option ${selectedHoneys[sample] === honey.id ? 'selected' : ''}`}
                    onClick={() => handleHoneySelection(sample, honey.id)}
                  >
                    <img 
                      src={`${process.env.PUBLIC_URL}${honey.image}`} 
                      alt={honey.name} 
                      className="honey-thumbnail" 
                    />
                    <span>{honey.name}</span>
                  </div>
                ))}
              </div>
              <div className="selected-honey">
                {selectedHoneys[sample] ? (
                  <p>Seleccionada: {honeyTypes.find(h => h.id === selectedHoneys[sample])?.name}</p>
                ) : (
                  <p>Ninguna miel seleccionada</p>
                )}
              </div>
            </div>
          ))}
        </div>
        
        <div className="admin-actions">
          <button 
            className="save-button"
            onClick={handleSaveConfiguration}
          >
            Guardar Configuración
          </button>
          <button 
            className="back-button"
            onClick={() => navigate('/')}
          >
            Volver al Inicio
          </button>
        </div>
      </div>
    </div>
  );
};

export default Admin;
